// extracted by mini-css-extract-plugin
module.exports = {"input":"input--c3ae1"};